'use client';

import { useEffect } from 'react';

import { useLocale } from '@/app/context/use-locale';

export default function HtmlLangUpdater() {
  const locale = useLocale();

  useEffect(() => {
    if (!locale) return;
    document.documentElement.lang = locale;
  }, [locale]);

  return null;
}
